export enum MinTimeAheadPeriodTypes {
  Hours = 0,
  Days = 1,
}
